/**
 * Malcriados · colores de la tarjeta de producto.
 *
 * Cada punto de color con [data-mc-color] cambia la foto de la tarjeta:
 * - Computador: al pasar el cursor se ve ese color; al salir vuelve.
 * - Celular y clic: al tocar queda elegido (anillo verde); tocarlo otra
 *   vez vuelve a la foto original.
 * El toque en el punto no abre el producto; el resto de la tarjeta sí.
 */

/** @param {Element} tarjeta */
function imagenDe(tarjeta) {
  return /** @type {HTMLImageElement | null} */ (tarjeta.querySelector('.mc-tarjeta-producto__foto img, .mc-home-tarjeta__foto img'));
}

/**
 * Con el filtro "N° de mascotas" puesto (tarjeta.dataset.mcN), la foto es la de esa cantidad de retratos
 * (de la tarjeta, o del color tocado si lo hay).
 * @param {Element} tarjeta
 * @param {Element | null} punto
 */
function mostrar(tarjeta, punto) {
  const img = imagenDe(tarjeta);
  if (!img) return;
  if (!img.dataset.mcOriginal) {
    img.dataset.mcOriginal = img.currentSrc || img.src;
    img.dataset.mcOriginalSet = img.getAttribute('srcset') ?? '';
  }
  const n = tarjeta instanceof HTMLElement ? tarjeta.dataset.mcN : '';
  if (punto) {
    const porRetratos = n ? punto.getAttribute(`data-foto-${n}`) : null;
    if (porRetratos) {
      img.removeAttribute('srcset');
      img.src = porRetratos;
    } else {
      img.srcset = punto.getAttribute('data-fotoset') ?? '';
      img.src = punto.getAttribute('data-foto') ?? img.src;
    }
    return;
  }
  const deLaTarjeta = n ? tarjeta.getAttribute(`data-foto-${n}`) : null;
  if (deLaTarjeta) {
    img.removeAttribute('srcset');
    img.src = deLaTarjeta;
  } else {
    if (img.dataset.mcOriginalSet) img.srcset = img.dataset.mcOriginalSet;
    else img.removeAttribute('srcset');
    img.src = img.dataset.mcOriginal;
  }
}

/** @param {Element} tarjeta */
function elegido(tarjeta) {
  return tarjeta.querySelector('[data-mc-color][aria-pressed="true"]');
}

/** @param {Element} punto */
function elegir(punto) {
  const tarjeta = punto.closest('[data-mc-tarjeta]');
  if (!tarjeta) return;
  const estabaElegido = punto.getAttribute('aria-pressed') === 'true';
  for (const otro of tarjeta.querySelectorAll('[data-mc-color]')) otro.setAttribute('aria-pressed', 'false');
  if (!estabaElegido) punto.setAttribute('aria-pressed', 'true');
  mostrar(tarjeta, estabaElegido ? null : punto);
}

document.addEventListener('click', (evento) => {
  const punto = evento.target instanceof Element ? evento.target.closest('[data-mc-color]') : null;
  if (!punto) return;
  evento.preventDefault();
  evento.stopPropagation();
  elegir(punto);
});

document.addEventListener('keydown', (evento) => {
  if (evento.key !== 'Enter' && evento.key !== ' ') return;
  const punto = evento.target instanceof Element ? evento.target.closest('[data-mc-color]') : null;
  if (!punto) return;
  evento.preventDefault();
  elegir(punto);
});

/* Solo con mouse: ver el color al pasar el cursor. */
document.addEventListener('pointerover', (evento) => {
  if (evento.pointerType !== 'mouse') return;
  const punto = evento.target instanceof Element ? evento.target.closest('[data-mc-color]') : null;
  const tarjeta = punto?.closest('[data-mc-tarjeta]');
  if (punto && tarjeta) mostrar(tarjeta, punto);
});

document.addEventListener('pointerout', (evento) => {
  if (evento.pointerType !== 'mouse') return;
  const origen = evento.target instanceof Element ? evento.target.closest('[data-mc-color]') : null;
  if (!origen) return;
  const destino = evento.relatedTarget instanceof Element ? evento.relatedTarget.closest('[data-mc-color]') : null;
  if (destino) return;
  const tarjeta = origen.closest('[data-mc-tarjeta]');
  if (tarjeta) mostrar(tarjeta, elegido(tarjeta));
});

/* El catalogo avisa cuando cambia el filtro de mascotas: cada tarjeta repinta su foto. */
document.addEventListener('mc:retratos', (evento) => {
  const tarjeta = evento.target instanceof Element ? evento.target : null;
  if (tarjeta) mostrar(tarjeta, elegido(tarjeta));
});

